import { ApplicationState } from '../../../../store/types';
import { CalculatorPromptDB, CalculatorPromptUI } from '../../calculator/store/types';
import { getClientCalculatorRoot } from '../../store/selectors';

export const getIsFetchingClientCalculatorPrompts = (state: ApplicationState): boolean => getClientCalculatorRoot(state).isFetchingCalculatorPrompts;

export const getIsSavingClientCalculatorPrompt = (state: ApplicationState): boolean => getClientCalculatorRoot(state).isSavingCalculatorPrompt;

export const getIsDeletingClientCalculatorPrompts = (state: ApplicationState): boolean => getClientCalculatorRoot(state).isDeletingCalculatorPrompt;

export const getAllClientCalculatorPrompts = (state: ApplicationState): CalculatorPromptDB[] => getClientCalculatorRoot(state).calculatorPrompts;

export const getSelectedClientCalculatorPrompt = (state: ApplicationState): CalculatorPromptUI | null => getClientCalculatorRoot(state).selectedCalculatorPrompt;

export const getClientCalculatorPromptToDelete = (state: ApplicationState): CalculatorPromptDB | null => getClientCalculatorRoot(state).calculatorPromptToDelete;

export const getClientCalculatorPromptUpdated = (state: ApplicationState): boolean => getClientCalculatorRoot(state).selectedPromptUpdated;

export const getCurrentClientCalculatorPromptOrderForType = (state: ApplicationState): CalculatorPromptDB[] => getClientCalculatorRoot(state).currentSelectedFieldTypePromptOrder;

export const getSavedClientCalculatorPromptOrderForType = (state: ApplicationState): CalculatorPromptDB[] => getClientCalculatorRoot(state).savedSelectedFieldTypePromptOrder;
